import { render, staticRenderFns } from "./AppointTipsDialog.vue?vue&type=template&id=463a5d43&"
import script from "./AppointTipsDialog.vue?vue&type=script&lang=js&"
export * from "./AppointTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppointTipsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports